import {useCallback} from 'react';
import {useQueryClient} from './react-query';

export function useInvalidateQueryCache() {
  const queryClient = useQueryClient();

  const invalidateRequests = useCallback(
    (methods: Array<string>) =>
      queryClient.invalidateQueries({
        predicate: query => {
          const methodName = (query.queryKey[0] as string)
            .replace('"', '')
            .split(':')[0];

          if (!methodName) {
            return false;
          }

          return methods.includes(methodName);
        },
      }),
    [queryClient],
  );

  return {
    invalidateRequests,
  };
}
